import dayjs from 'dayjs';

export const getTimer = (date, current = dayjs().add((new Date()).getTimezoneOffset(), 'm')) => {
  const diffMinutes = date.diff(current, 'm');
  const diffSeconds = date.diff(current, 's');
  return `${diffMinutes}:${diffSeconds%60}`;
};
